<template>
  <div>
    <el-dialog
        :visible.sync="isOpenAddTicketAppDialog"
        width="1500px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="3vh"
        title="Thêm phiếu bé ngoan"
        border
        @open="handleOpen"
    >
      <el-form
          label-width="140px"
          :model="createTicketAppRequest"
          label-position="left"
          :rules="rules"
          ref="createTicketAppRequest"
      >
        <el-row :gutter="100">
          <el-col :span="12">
            <div class="grid-content">
              <el-form-item label="Tên phiếu bé ngoan" prop="nameTicket" label-width="170px">
                <el-input
                    v-model="createTicketAppRequest.nameTicket"
                    placeholder="Nhập tên"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Mô tả" prop="descriptionTicket" label-width="80px">
              <el-input
                  v-model="createTicketAppRequest.descriptionTicket"
                  placeholder="Nhập mô tả"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="Màn hình" label-width="170px">
            <el-select v-model="displayTicket" placeholder="Chọn màn hình" @change="handleChangeDisplayTicket"
                       style="width: 200px">
              <el-option
                  style="width: 200px"
                  v-for="item in listDisplayTicket"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="dataTarget" label="Chọn trường" label-width="170px">
            <el-col :span="3">
              <el-select
                  style="width: 170px;"
                  v-model="dataSearch.active"
                  @change="searchHeaderMethod()"
                  placeholder="Trạng thái kích hoạt"
                  clearable
              >
                <el-option
                    v-for="item in statusAccountList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" style="margin-left: 35px">
              <!-- trạng thái xóa -->
              <el-select
                  style="width: 160px"
                  class="button-left-class"
                  v-model="dataSearch.deleteStatus"
                  placeholder="Trạng thái xóa"
                  @change="searchHeaderMethod()"
                  clearable
              >
                <el-option
                    v-for="item in deleteList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" style="margin-left: 25px">
              <el-input
                  v-model="dataSearch.nameSchool"
                  style="width: 250px"
                  placeholder="Nhập tên trường"
                  @clear="searchHeaderMethod()"
                  clearable
                  @keyup.enter.native="searchHeaderMethod()"
              >
                <template #append>
                  <el-button
                      icon="el-icon-search"
                      @click="searchHeaderMethod()"
                  ></el-button>
                </template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <div>
            <el-transfer
                style="margin-left: 170px; margin-bottom: 20px; margin-right: 75px"
                :element-loading-text="$tableLoading"
                v-loading="loadingDataTransfer"
                v-model="dataTarget"
                :titles="['Tất cả trường chưa chọn', 'Trường được chọn']"
                :button-texts="['', '']"
                :data="dataSource"
            >
              <template></template>
            </el-transfer>
          </div>

        </el-row>

        <!--        Phiếu bé ngoan-->
        <div style="margin-left: 170px; margin-right: 170px">
          <el-upload
              style="clear: both"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :file-list="fileListTicket"
              :on-change="handleChangePictureTicket"
              :on-remove="handleRemoveTicket"
              :before-remove="beforeRemove"
              :on-preview="handlePictureCardPreviewTicket"
              multiple
              ref="uploadTicket"
          >
            <i slot="default" class="el-icon-plus" style="font-style: normal; white-space: nowrap">Thêm Ảnh</i>
          </el-upload>
          <el-dialog width="50%" :visible.sync="dialogVisibleTicket">
            <img width="100%" :src="dialogImageUrlTicket" alt/>
          </el-dialog>
        </div>

        <div class="tab-infor-button">
          <el-button
              type="success"
              size="medium"
              :loading="loadingButton"
              mini
              @click="submitForm('createTicketAppRequest')"
          >
            <i class="el-icon-circle-check"/>
            <span>Lưu</span>
          </el-button>
          <el-button
              type="danger"
              size="medium"
              @click="closeDialog()"
          >
            <i class="el-icon-circle-close"/>
            <span>Đóng</span>
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";
import {listDisplayTicket, parentScreenList, plusScreenList, teacherScreenList} from "@/constant/listTemplate";
import templateConfigMixin from "@/global/mixinTemplate/templateConfig.mixin";
import ManageDataService from "@/services/AdminService/ManageDataService";
import SystemConfigTicket from "@/services/AdminService/SystemConfigTicket";

export default {
  components: {},
  props: {
    isOpenAddTicketAppDialog: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      agentList: "",
      checkedKeepPhoto: true,
      disabled: false,
      loadingData: true,
      loadingButton: false,
      dialogVisiblePicture: false,
      showUpload: false,

      createTicketAppRequest: {
        nameTicket: "",
        descriptionTicket: "",
        appType: "plus",
        listMap: {},

      },
      plusScreenList,
      teacherScreenList,
      parentScreenList,
      listTicketLearn: [],
      listTicketEat: [],
      listTicketSleep: [],
      listTicketToilet: [],
      listTicketHealthy: [],
      listTicketComment: [],
      listTicketWeek: [],
      listTicketMonth: [],
      listTicketPeriodic: [],
      listTicket: [],
      typePackage: "template",
      displayTicket: 1,
      listDisplayTicket,
      fileListTicket: [],
      dialogVisibleTicket: false,
      dialogImageUrlTicket: '',
      colorText: "#FFFFFF",
      rules: {
        nameTicket: [
          {
            required: true,
            message: "Không được để trống",
            trigger: "blur",
          },
        ],
        appType: [
          {
            required: true,
            message: "Loại app không được để trống",
            trigger: "change",
          },
        ],
        idSchool: [
          {
            required: true,
            message: "Phải chọn trường",
            trigger: "change",
          },
        ],
      },

      statusAccountList: [
        {
          key: true,
          value: "Đã kích hoạt",
        },
        {
          key: false,
          value: "Chưa kích hoạt",
        },
      ],
      deleteList: [
        {key: true, value: "Chưa xóa"},
        {key: false, value: "Đã xóa"},
      ],
      dataSearch: {
        deleteStatus: true,
        active: true,
        nameSchool: "",
      },
      listSchool: [],
      loadingDataTransfer: false,
      dataSource: [],
      dataTarget: [],
    };
  },
  watch: {
    "createTicketAppRequest.appType"(newValue) {
      if (newValue !== 'plus') {
        this.typePackage = 'template';
      }
    },
    listSchool: {
      handler() {
        if (this.listSchool.length > 0) {
          setTimeout(() => {
                this.loadingDataTransfer = false
              }
              , 1000
          )
        }
      }
    }
  },
  mixins: [
    templateConfigMixin
  ],
  computed: {
    ...mapState('schoolStore', ['agentList']),
    ...mapState('schoolStore', ['schoolList']),
  },
  methods: {
    ...mapActions('schoolStore', ["fetchDataSchoolList"]),
    getFileList(file) {
      return file ? [file] : [];
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },

    closeDialog() {
      this.clearAllData();
      this.$refs["createTicketAppRequest"].resetFields();
      this.$emit("dialog-close");
    },
    closeDialogByButton(fromData) {
      this.clearAllData();
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
    },

    clearAllData() {
      this.dataSearch.nameSchool = ""
      this.dataSearch.active = true
      this.dataSearch.deleteStatus = true
      this.colorText = "#FFFFFF"
      this.listTicketLearn = []
      this.listTicketEat = []
      this.listTicketSleep = []
      this.listTicketToilet = []
      this.listTicketHealthy = []
      this.listTicketComment = []
      this.listTicketWeek = []
      this.listTicketMonth = []
      this.listTicketPeriodic = []
      this.typePackage = "template"
      this.fileListTicket = []
      this.agentList = ""
      this.checkedKeepPhoto = true
      this.loadingData = true
      this.loadingButton = false
      this.dialogVisiblePicture = false
      this.showUpload = false
      this.createTicketAppRequest =
          {
            idSchool: "",
            nameSchool: "",
            nameTicket: "",
            descriptionTicket: "",
            appType: "plus",
            listMap: {},
          }
      this.handleClearList()
      setTimeout(() => {
        this.dataSource = [];
        this.dataTarget = [];
      }, 500);
    },

    handleClearList() {
      for (let i = 0; i < this.plusScreenList.length; i++) {
        this.plusScreenList[i].file = null;
        this.plusScreenList[i].url = '';
        this.plusScreenList[i].showFile = true;
        this.plusScreenList[i].id = null
        this.plusScreenList[i].showFile = true
        this.plusScreenList[i].disabled = false
        this.plusScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        this.teacherScreenList[i].file = null;
        this.teacherScreenList[i].url = "";
        this.teacherScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        this.parentScreenList[i].file = null;
        this.parentScreenList[i].url = '';
        this.parentScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
    },

    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("nameTicket", this.createTicketAppRequest.nameTicket);
          formData.append("descriptionTicket", this.createTicketAppRequest.descriptionTicket);
          formData.append("idSchoolList", this.dataTarget);
          // if (this.createTicketAppRequest.appType === "plus") {
          //   for (let i = 0; i < this.plusScreenList.length; i++) {
          //     if (this.plusScreenList[i].file != null) {
          //       formData.append(`listMap[${this.plusScreenList[i].key}]`, this.plusScreenList[i].file.raw);
          //     }
          //   }
          // } else if (this.createTicketAppRequest.appType === "teacher") {
          //   for (let i = 0; i < this.teacherScreenList.length; i++) {
          //     if (this.teacherScreenList[i].file != null) {
          //       formData.append(`listMap[${this.teacherScreenList[i].key}]`, this.teacherScreenList[i].file.raw);
          //     }
          //   }
          // } else {
          //   for (let i = 0; i < this.parentScreenList.length; i++) {
          //     if (this.parentScreenList[i].file != null) {
          //       formData.append(`listMap[${this.parentScreenList[i].key}]`, this.parentScreenList[i].file.raw);
          //     }
          //   }
          // }

          this.addImageTicketFormData(formData, this.listTicketLearn, this.listTicketEat, this.listTicketSleep, this.listTicketToilet,
              this.listTicketHealthy, this.listTicketComment, this.listTicketWeek, this.listTicketMonth, this.listTicketPeriodic)

          this.loadingButton = true;
          SystemConfigTicket.createTicketAppSystem(formData)
              .then((resp) => {
                this.$message({
                  message: resp.data.message,
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        }
      });
    },

    handleRemove(row, file) {
      console.log(file)
      if (this.createTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = null;
            this.plusScreenList[i].url = '';
            this.plusScreenList[i].showFile = true;
          }
        }
      } else if (this.createTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = null;
            this.teacherScreenList[i].url = "";
            this.teacherScreenList[i].showFile = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = null;
            this.parentScreenList[i].url = '';
            this.parentScreenList[i].showFile = true;
          }
        }
      }
    },

    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    handlePictureCardPreview(row, file) {
      if (this.createTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].dialogImg = true;
          }
        }
      } else if (this.createTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].dialogImg = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].dialogImg = true;
          }
        }
      }
    },


    handleChangePicture(row, file) {
      if (this.createTicketAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = file;
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].showFile = false;
          }
        }
      } else if (this.createTicketAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = file;
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].showFile = false;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = file;
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].showFile = false;
          }
        }
      }
      this.checkedKeepPhoto = false
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
      }
      return isJPG && isLt5M;
    },

    handleChangeDisplayTicket() {
      this.fileListTicket = []
      switch (this.displayTicket) {
        case 1: {
          this.fileListTicket = this.listTicketLearn
          break;
        }
        case 2: {
          this.fileListTicket = this.listTicketEat
          break;
        }
        case 3: {
          this.fileListTicket = this.listTicketSleep
          break;
        }
        case 4: {
          this.fileListTicket = this.listTicketToilet
          break;
        }
        case 5: {
          this.fileListTicket = this.listTicketHealthy
          break;
        }
        case 6: {
          this.fileListTicket = this.listTicketComment
          break;
        }
        case 7: {
          this.fileListTicket = this.listTicketWeek
          break;
        }
        case 8: {
          this.fileListTicket = this.listTicketMonth
          break;
        }
        case 9: {
          this.fileListTicket = this.listTicketPeriodic
          break;
        }
      }
    },
    // Chọn ảnh phiếu bé ngoan
    handleChangePictureTicket(file, fileList) {
      this.fileListTicket = fileList
      switch (this.displayTicket) {
        case 1: {
          this.listTicketLearn = this.fileListTicket
          break;
        }
        case 2: {
          this.listTicketEat = this.fileListTicket
          break;
        }
        case 3: {
          this.listTicketSleep = this.fileListTicket
          break;
        }
        case 4: {
          this.listTicketToilet = this.fileListTicket
          break;
        }
        case 5: {
          this.listTicketHealthy = this.fileListTicket
          break;
        }
        case 6: {
          this.listTicketComment = this.fileListTicket
          break;
        }
        case 7: {
          this.listTicketWeek = this.fileListTicket
          break;
        }
        case 8: {
          this.listTicketMonth = this.fileListTicket
          break;
        }
        case 9: {
          this.listTicketPeriodic = this.fileListTicket
          break;
        }
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      return true;
    },
    // Xem chi tiết ảnh phiếu bé ngoan
    handlePictureCardPreviewTicket(file) {
      this.dialogImageUrlTicket = file.url;
      this.dialogVisibleTicket = true;
    },
    // Xóa file phiếu bé ngoan
    handleRemoveTicket(file) {
      this.$refs.uploadTicket.clearFiles();
      let index;
      for (let i = 0; i < this.fileListTicket.length; i++) {
        if (file.uid === this.fileListTicket[i].uid) {
          index = i
        }
      }
      if (index >= 0) {
        this.fileListTicket.splice(index, 1);
      }
      let indexTicket;
      switch (this.displayTicket) {
        case 1: {
          for (let i = 0; i < this.listTicketLearn.length; i++) {
            if (file.uid === this.listTicketLearn[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketLearn.splice(indexTicket, 1);
          }
          break;
        }
        case 2: {
          for (let i = 0; i < this.listTicketEat.length; i++) {
            if (file.uid === this.listTicketEat[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketEat.splice(indexTicket, 1);
          }
          break;
        }
        case 3: {
          for (let i = 0; i < this.listTicketSleep.length; i++) {
            if (file.uid === this.listTicketSleep[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketSleep.splice(indexTicket, 1);
          }
          break;
        }
        case 4: {
          for (let i = 0; i < this.listTicketToilet.length; i++) {
            if (file.uid === this.listTicketToilet[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketToilet.splice(indexTicket, 1);
          }
          break;
        }
        case 5: {
          for (let i = 0; i < this.listTicketHealthy.length; i++) {
            if (file.uid === this.listTicketHealthy[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketHealthy.splice(indexTicket, 1);
          }
          break;
        }
        case 6: {
          for (let i = 0; i < this.listTicketComment.length; i++) {
            if (file.uid === this.listTicketComment[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketComment.splice(indexTicket, 1);
          }
          break;
        }
        case 7: {
          for (let i = 0; i < this.listTicketWeek.length; i++) {
            if (file.uid === this.listTicketWeek[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketWeek.splice(indexTicket, 1);
          }
          break;
        }
        case 8: {
          for (let i = 0; i < this.listTicketMonth.length; i++) {
            if (file.uid === this.listTicketMonth[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketMonth.splice(indexTicket, 1);
          }
          break;
        }
        case 9: {
          for (let i = 0; i < this.listTicketPeriodic.length; i++) {
            if (file.uid === this.listTicketPeriodic[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketPeriodic.splice(indexTicket, 1);
          }
          break;
        }
      }
    },

    handleTypeApp() {
      if (this.createTicketAppRequest.appType !== 'plus') {
        this.typePackage = 'template'
      }
    },

    async searchHeaderMethod() {
      this.loadingDataTransfer = true
      this.dataTarget = []
      await ManageDataService.searchSchoolTransfer(this.dataSearch.deleteStatus, this.dataSearch.active, this.dataSearch.nameSchool).then((res) => {
        this.listSchool = res.data.data.schoolList
      })
      await this.setDataSource()
    },

    handleOpen() {
      this.loadingDataTransfer = false
      this.searchHeaderMethod();
    },

    setDataSource() {
      const dataResponse = [];
      this.listSchool.forEach((school) => {
        dataResponse.push({
          label: school.id + " -- " + school.schoolName,
          key: school.id,
        });
      });
      this.dataSource = dataResponse;
    },


  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>
// /deep/.el-input__inner,
// /deep/.el-textarea__inner {
//   border: none;
//   border-radius: 0;
//   resize: none;
//   padding-left: 0;
//   padding-right: 0;
//   border-bottom: 1px solid #d9d9d9;
// }

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-upload--picture-card {
  background: none;
  border-radius: 6px;
  border: none; /* Default border */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

/deep/ .el-table th.gutter {
  background-color: #78a5e7;
}

/deep/ .el-upload-list__item.is-ready > div {
  height: 100%;
}

.tag_image {
  background: #409effe6;
  position: absolute;
  left: -20px;
  top: -4px;
  width: 60px;
  padding: 6px 0 0 0;
  text-align: center;
  color: #fff;
  rotate: -45deg;
  font-size: 12px;
  text-transform: capitalize;
}

/deep/ .el-image__inner {
  object-fit: cover;
}

/deep/ .el-transfer-panel__body {
  height: 300px;
}

/deep/ .el-transfer-panel__list.is-filterable {
  height: 245px;
  padding-top: 0;
}

/deep/ .el-transfer-panel .el-transfer-panel__header {
  background: #78a5e7;
}

/deep/ .el-transfer-panel
.el-transfer-panel__header
.el-checkbox
.el-checkbox__label
span {
  color: white;
}

/deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  color: white;
}

/deep/ .el-transfer-panel {
  width: 40%;
}

/deep/ .el-transfer__buttons {
  display: inline-flex;
  vertical-align: middle;
  padding: 0 10px;
}

/deep/ .el-button--primary {
  width: 100%;
  height: 100%;
}
</style>
